import { render } from "./BalanceCard.vue?vue&type=template&id=18244af3&scoped=true"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"

import "./BalanceCard.vue?vue&type=style&index=0&id=18244af3&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18244af3"]])

export default __exports__